export const SITE_URL = document.referrer || "https://www.nerdwallet.com/";

export const DETROIT_GENERATOR_ID = "0000-5034";
export const DETROIT_PASSWORD =
  "ZDn3PkmeKsHoRjcaSNujKdRh9JqZeUW8+DJ3Jbil8+FSJ8snaadT8oj6JV3BqtJlMOQXNSIkpI6nu1CDwgNmCg==";

export const AUTOWEB_PROVIDER_ID = 35270;

// it will Ping 4 times this number, +/- per zip code, and the AutoWeb and Detroit APIs
export const ZIPS_LOOKOUT_RANGE = 100;
export const ZIPS_LOOKOUT_STEP = 10;

export const AUTOWEB_YEAR = 2023;
